<template>
	<Col class="overflow-x-hidden">
		<InboxNotificationsMenuTabs class="pl-7 mb-8" :tabs="tabs" :selectedTabIndex.sync="selectedTabIndex" />
		<Col class="pb-8 scroll-on-overflow">
			<AppPagination
				:idsToHide="idsToHide"
				:key="selectedTabIndex"
				:useItemGetter="getAlert"
				:idsToAppend="idsToAppend"
				:idsToPrepend="idsToPrepend"
				:noResultsMessage="noResultsMessage"
				:getItemsAction="getAlertsWrapper"
				:additionalFetchParams="additionalFetchParams"
			>
				<template #list-item="{ item }">
					<InboxNotificationsItemDataProvider v-if="initialized" :alert="item" :archivedMode="archivedMode" />
				</template>
			</AppPagination>
		</Col>
	</Col>
</template>
<script>
const extractCursorFromUrl = (url) => {
	const urlParams = new URLSearchParams(url);
	return urlParams.get('cursor');
};
import InboxService from './inbox-service';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import InboxNotificationsMenuTabs from '@/components/Inbox/InboxNotificationsMenuTabs.vue';
import { getAlertsByInboxId, getAlert as fetchAlert } from '@/store/modules/alerts/actions';
import InboxNotificationsItemDataProvider from '@/components/Inbox/InboxNotificationsItemDataProvider.vue';
import { getAlert, useClientSideActiveAlerts, useClientSideArchivedAlerts, useAlertsIdsByInboxId } from '@/store/modules/alerts/getters';
export default {
	name: 'InboxNotificationsMenu',
	components: {
		InboxNotificationsMenuTabs,
		InboxNotificationsItemDataProvider,
	},
	props: {
		inboxId: { type: [String, Number] },
		alertIdToStickAtTop: { type: [String, Number] },
	},
	computed: {
		...mapGettersShorthand({ getAlert, useClientSideActiveAlerts, useClientSideArchivedAlerts, useAlertsIdsByInboxId }),
		additionalRelevantAlertIdsFromStore() {
			return this.useAlertsIdsByInboxId({ inboxId: this.inboxId, isArchived: this.archivedMode });
		},
		additionalFetchParams() {
			return { id: this.inboxId, archived: this.archivedMode };
		},
		noResultsMessage() {
			return 'No notifications found';
		},
		idsToHide() {
			return [];
		},
		idsToAppend() {
			return this.idsToAppendFromStore;
		},
		idsToPrepend() {
			let ids = [...this.incomingAlertIds];
			if (this.showClientSideAlerts) {
				if (this.archivedMode) {
					ids = [...ids, ...this.useClientSideArchivedAlerts.map(({ id }) => id)];
				} else {
					ids = [...ids, ...this.useClientSideActiveAlerts.map(({ id }) => id)];
				}
			}
			if (this.alertIdToStickAtTop) {
				return [...new Set([this.alertIdToStickAtTop, ...ids])];
			}
			return [...new Set(ids)];
		},
		showClientSideAlerts() {
			return InboxService.doesInboxIncludePersonalItems(this.inboxId);
		},
		archivedMode() {
			return Boolean(this.tabs[this.selectedTabIndex].archived);
		},
		initialized() {
			if (this.alertIdToStickAtTop) {
				return this.fetchedAlertToStickAtTop;
			}
			return true;
		},
	},
	methods: {
		...mapActionsShorthand({ getAlertsByInboxId, fetchAlert }),
		getAlertsWrapper(params) {
			if (params.next) {
				// Get cursor from the full URL.
				params['cursor'] = extractCursorFromUrl(params.next);
			}
			return this.getAlertsByInboxId(params);
		},
	},
	data() {
		return {
			selectedTabIndex: 0,
			incomingAlertIds: [],
			idsToAppendFromStore: [],
			fetchedAlertToStickAtTop: false,
			tabs: [{ title: 'New' }, { title: 'Archived', archived: true }],
		};
	},
	watch: {
		additionalRelevantAlertIdsFromStore: {
			handler(newV, oldV) {
				if (oldV && newV.length - oldV.length === 1) {
					this.incomingAlertIds = [...newV.filter((id) => !oldV.includes(id)), ...this.incomingAlertIds];
				}
				this.idsToAppendFromStore = [...new Set([...this.idsToAppendFromStore, ...newV])].sort((a, b) => b - a);
			},
			immediate: true,
		},
		selectedTabIndex: {
			handler() {
				this.incomingAlertIds = [];
				this.idsToAppendFromStore = [...this.additionalRelevantAlertIdsFromStore];
			},
		},
		alertIdToStickAtTop: {
			async handler(newV) {
				if (newV) {
					this.fetchedAlertToStickAtTop = false;
					await this.fetchAlert({ id: newV });
					this.fetchedAlertToStickAtTop = true;
				}
			},
			immediate: true,
		},
	},
};
</script>
<style scoped lang="scss">
::v-deep {
	.no-results {
		margin-top: 30px;
	}
	.loader {
		margin-top: 20px;
	}
}
</style>
